// ⭐ EDIT THIS FILE — replace phone / WhatsApp / address with the resort's real details
export const siteConfig = {
  name: "USHA Resort",
  tagline: "Patna · Bihar",

  // 🖼️ Logo — put your PNG in: public/images/logo.png
  // Set to null (or delete the file) to use the "U" letter badge instead
  logo: "/images/logo.png",

  // TODO: Replace with the resort's real number (country code + number, no + or spaces)
  whatsapp: "917260059888",

  // TODO: Replace with real display number
  phone: "+91 72600 59888",
  phoneHref: "tel:+917260059888",

  email: "usharesort40@gmail.com",

  // TODO: Replace with full real address
  address: "Usha Resort, Dharamsala more, marcha - marchi road, Narayan Nagar, bypas, thana, Patna, Bihar 800009",

  hours: "Open 24 × 7 · All Days",

  social: {
    facebook: "https://www.facebook.com/profile.php?id=61557835415420",
    instagram: "https://www.instagram.com/usha.resort/",
    youtube: "https://www.youtube.com/@usharesort",
  },
};